<template>
  <div class="">
    <v-container fluid class="pt-0 ">

      <div class="Formcard pa-0 no-shadow pa-2 card-r">
        <v-toolbar class="primary card-r pl-3 text-white">
          <div class="text-xs-left f-20">Add Customer</div>
        </v-toolbar>

        <v-form v-model="loginAdmin" row class="mt-3 mb-3">
          <v-stepper v-model="createSchool" class="grey lighten-4 card-r no-shadow">
            <v-layout wrap>
              <v-flex md3 sm3 xs3 lg3 class="pt-3">
                <v-stepper-header class="card-r no-shadow">
                  <div class="text-xs-left pl-4 f-15 font-weight-bold">Creating Steps</div>

                  <v-stepper-step xs4 :complete="createSchool > 1" step="1">School Details</v-stepper-step>
                  <v-stepper-step xs4 :complete="createSchool > 2" step="2">Admin Details</v-stepper-step>
                  <v-stepper-step xs4 :complete="createSchool > 3" step="3">Select Product </v-stepper-step>
                </v-stepper-header>
              </v-flex>
              <v-flex md9 sm12 xs12 lg9 class=" ">
                <v-stepper-items class="pt-3 no-shadow">
                  <v-stepper-content step="1" class="no-shadow">
                    <div class="text-xs-center f-15 font-weight-bold">Step 1 of 3</div>
                    <form class="transparent">
                      <v-card flat class="pl-2text-xs-center card-r no-shadow " color="transparent">
                        <v-layout wrap row>
                          <!-- <div class="f-15 w-100 textColor pl-2 text-xs-left font-weight-bold">School Details</div> -->
                          <v-flex lg6 md12 sm12 xs12 class="pa-1">
                            <v-text-field solo
                              name="Cvr"
                              label="CVR Number"
                              v-model="club.cvr"
                              class=" input-group--focused "
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 md12 sm12 xs12 class="pa-1">
                            <v-text-field solo
                              name="School Name"
                              label="School Name"
                              :rules="requiredRule"
                              v-model="club.club_name"
                              class=" input-group--focused "
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 md12 sm12 xs12 class="pa-1">
                            <v-text-field solo
                              name="Phone"
                              prefix="+45"
                              maxlength="8"
                              label="Phone Number"
                              type="number"
                              v-model="club.club_phone"
                              :rules="numberRules"
                              class=" input-group--focused"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 md12 sm12 xs12 class="pa-1">
                            <v-text-field solo
                                          name="Email"
                                          label="Email"
                                          :rules="emailRules"
                                          v-model="club.club_email"
                                          class=" input-group--focused"
                                          required
                            ></v-text-field>
                          </v-flex>
                          <v-flex md12 sm12 xs12 class="pa-1">
                            <v-flex md12 sm12 xs12 class="shadow-1 white pa-1">
                              <vue-dawa
                                class="w-100"
                                @select="selectItem($event , 'clubAddress')"
                                :val="clubAddress.oneLineAddress"
                                :showMax="5"
                                placeholder="Address"
                                containerId="address_container"
                                fieldId="address_id"
                                fieldName="address_name">
                                <!--<label slot="label-top" class="active">Address</label>-->
                              </vue-dawa>
                            </v-flex>
                          </v-flex>
                        </v-layout>
                      </v-card>
                      <!-- <v-btn color="primary right card-r " @click="createSchool = 2 ">Next</v-btn> -->
                    <v-btn color="primary right card-r" @click="createSchool = 2" :disabled="NextDisabled"> Next </v-btn>
                    
                    </form>
                  </v-stepper-content>
                  <v-stepper-content step="2" class="no-shadow">
                    <div class="text-xs-center f-15 font-weight-bold">Step 2 of 3</div>
                    <form >
                      <v-card class="text-xs-center card-r no-shadow " color="transparent">
                        <v-layout row wrap>
                          <!-- <div class="f-15 w-100 textColor font-weight-bold">Admin Details</div> -->
                          <v-flex lg4 md12 sm12 xs12 class="pa-1">
                            <v-text-field solo
                            name="Phone"
                            prefix="+45"
                            label="Phone Number"
                            maxlength="8"
                            :rules="numberRules"
                            type="number"
                            v-model="admin.phone"
                            class=" input-group--focused"
                            required
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 md12 sm12 xs12 class="pa-1">
                            <v-text-field solo
                              name="Email"
                              label="Email"
                              :rules="emailRules"
                              v-model="admin.email"
                              class=" input-group--focused"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 md12 sm12 xs12 class="pa-1">
                            <v-text-field solo
                              name="Password"
                              label="Password"
                              :type="passwordShow ? 'text' : 'password'"
                              :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                              @click:append="passwordShow = !passwordShow"
                              v-model="admin.password"
                              :rules="passwordRules"
                              class=" input-group--focused"
                              required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card>
                      <v-btn color="primary right card-r"  @click="createSchool = 3" :disabled="Next2Disabled">Next</v-btn>
                      <v-btn @click="createSchool =  1 " class="right card-r no-shadow">Back</v-btn>
                    </form>
                  </v-stepper-content>
                  <v-stepper-content step="11">
                    <v-card class="mb-5 text-xs-center card-r no-shadow py-5 card-r" color="transparent">
                      <v-flex md12 sm12 xs12 class="0">
                        <v-card class="pa-2 mb-2 ma-1 card-r no-shadow text-xs-left">
                          <input
                            type="file"
                            style="display:none"
                            ref="logoInput"
                            accept="image/png"
                            @change="OnLogoPicked">
                          <v-btn class="card-r" small outline @click="onPickLogo">Upload Logo</v-btn>
                          <div class="ma-2" v-if="club.club_logo != ''">
                            <span>{{club.club_logo_name}}</span>
                            <v-icon small @click="club.club_logo = ''">delete</v-icon>
                          </div>
                        </v-card>
                        <v-card class="pa-2 mb-2 ma-1 card-r no-shadow text-xs-left">
                          <input
                            type="file"
                            style="display:none"
                            ref="CoverInput"
                            accept="image/png"
                            @change="OnCoverPicked"
                          >
                          <v-btn
                            small
                            class="card-r"
                            outline
                            @click="onPickCover"
                          >Upload Cover Photo</v-btn>

                          <div class="ma-2" v-if="club.club_cover != ''">
                            <span>{{club.club_cover_name}}</span>
                            <v-icon small @click="club.club_cover = ''">delete</v-icon>
                          </div>
                        </v-card>
                      </v-flex>

                      <v-flex md12 sm12 xs12 class="0">
                        <v-card class="text-xs-left card-r no-shadow pa-2 mb-2 ma-1">
                          <v-flex xs12 class="">
                            <input
                              type="file"
                              style="display:none"
                              ref="ImgInput"
                              accept="image/*"
                              @change="onImgPicked"
                            >
                            <v-btn
                              small
                              class="card-r"
                              outline
                              @click="onPickImg"
                            >Upload Gallery</v-btn>
                          </v-flex>
                          <v-flex class="ma-2" v-for="n in attachment.photosURL" :key="n" xs4 d-flex>
                            <v-card flat tile class="d-flex">
                              <v-img
                                :src="n"
                                :lazy-src="n"
                                aspect-ratio="1"
                                class="grey lighten-2">
                                <v-layout
                                  slot="placeholder"
                                  fill-height
                                  align-center
                                  justify-center
                                  ma-0>
                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-layout>
                              </v-img>
                            </v-card>
                          </v-flex>
                        </v-card>
                        <v-card class="text-xs-left card-r no-shadow pa-2 ma-1">
                          <v-flex xs12 class="">
                            <input
                              type="file"
                              style="display:none"
                              ref="VideoInput"
                              accept="video/*"
                              @change="onVideoPicked">
                            <v-btn
                              small
                              class="card-r"
                              outline
                              @click="onPickVideo"
                            >Upload Video</v-btn>
                          </v-flex>
                        </v-card>
                      </v-flex>
                    </v-card>
                    <v-btn color="primary right card-r no-shadow" @click="createSchool = 4 ">Next</v-btn>
                    <v-btn @click="createSchool = 2 " class="right card-r no-shadow">Back</v-btn>
                  </v-stepper-content>
                  <v-stepper-content step="3" class="no-shadow h-50">
                    <div class="text-xs-center f-15 font-weight-bold">Step 3 of 3</div>
                    <v-container fluid grid-list-xl class="text-xs-left pa-0">
                      <!-- <span class="f-15 w-100 textColor text-xs-left font-weight-bold">Select Package</span> -->
                      <v-layout row wrap class="text-xs-center">
                        <v-flex d-flex lg6 sm6 xs12 v-for="item in adminpackages" v-bind:key="item">
                          <v-card class="pa-3 shadow-1 card-r grey lighten-3">
                            <div class="f-20 font-weight-bold ">Driver</div>
                            <span class="f-15 pa font-weight-bold blue-grey--text">{{item.name}}</span>
                            <v-layout xs12>
                              <v-flex xs12 class="text-xs-left pa-2 grey--text f-12">
                                <ul>
                                  <li v-for="ben in item.benefits" v-bind:key="ben">{{ben}}</li>
                                </ul>
                              </v-flex>
                            </v-layout>
                            <v-layout xs12>
                              <v-flex xs6 class="text-xs-center pa-0">
                                <span class="font-weight-bold f-12 blue-grey--text">Duration</span>
                              </v-flex>
                              <v-flex xs6 class="text-xs-center pa-0">
                                <span class="font-weight-bold f-15">{{item.duration}} Days</span>
                              </v-flex>
                            </v-layout>
                            <v-layout xs12>
                              <v-flex xs6 class="text-xs-center pa-0">
                                <span class="font-weight-bold f-12 blue-grey--text">Total Cost</span>
                              </v-flex>
                              <v-flex xs6 class="text-xs-center pa-0">
                                <span class="font-weight-bold f-15">KR {{item.cost}}</span>
                              </v-flex>
                            </v-layout>
                            <v-layout xs12>
                              <v-flex xs6 class="text-xs-left">
                              </v-flex>
                              <v-flex xs6 class="text-xs-right">
                               </v-flex>
                            </v-layout>
                            <v-btn  color="no-shadow primary white--text card-r w-100 ma-0" dark v-if="SelectedPackageId!=item.id" @click="choosePackage(item,item.id)">Buy</v-btn>
                            <v-btn  color="no-shadow green white--text card-r w-100 ma-0" dark v-if="SelectedPackageId==item.id"><v-icon>check</v-icon>Selected</v-btn>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <!-- <v-btn @click="save()" class="primary right card-r no-shadow">Finish</v-btn> -->
                    <confirm-package v-bind:packageName="selectedPackage.name" v-bind:packagePrice="selectedPackage.cost" v-bind:packageId="SelectedPackageId" v-on:save="save(SelectedPackageId)"></confirm-package>
                    <v-btn @click="createSchool =  2 " class="right card-r">Back</v-btn>
                    </v-stepper-content>
                  <v-stepper-content step="33">
                    <div class="text-xs-center f-15">Step 4 of 5</div>
                    <form>
                      <v-card class="text-xs-center card-r no-shadow" color="transparent">
                        <v-layout row wrap>
                          <v-flex md12 sm12 xs12 class="0 checkbox">
                            <v-checkbox
                              v-model="policy"
                              :rules="[v => !!v || 'You must agree to continue!']"
                              label="Same The Profile Info"
                              class=" input-group--focused mt-0"
                              color="primary"
                              required
                            ></v-checkbox>
                          </v-flex>
                          <v-flex md12 sm12 xs12 class="0">
                            <v-text-field
                              name="Full name"
                              label="Full name"
                              v-model="Fullname"
                              class=" input-group--focused mt-0"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex md12 sm12 xs12 class="0">
                            <v-text-field
                              name="Address"
                              label="Address"
                              type="text"
                              v-model="Address"
                              class=" input-group--focused mt-0"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex md12 sm12 xs12 class="0">
                            <v-text-field
                              name="City"
                              label="City"
                              type="text"
                              v-model="City"
                              class=" input-group--focused mt-0"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex md12 sm12 xs12 class="0">
                            <v-text-field
                              name="Zip code"
                              label="Zip code"
                              type="text"
                              v-model="Zipcode"
                              class=" input-group--focused mt-0"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex md12 sm12 xs12 class="0">
                            <v-text-field
                              name="Country"
                              label="Country"
                              type="text"
                              v-model="Country"
                              class=" input-group--focused mt-0"
                              required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card>
                      <v-btn color="primary right card-r no-shadow"  @click="createSchool = 5">Next</v-btn>
                      <v-btn @click="createSchool = 3 " class="right card-r no-shadow">Back</v-btn>
                    </form>
                  </v-stepper-content>

                  <v-stepper-content step="dd5">
                    <div class="text-xs-center f-15">Step 5 of 5</div>
                    <form>
                      <v-card class="text-xs-center card-r no-shadow" color="transparent">
                        <v-layout row wrap>
                          <v-flex md12 wrap sm12 xs12 class="0">
                            <div class="card-type "></div>
                            <div class="card-type mastercard"></div>
                            <div class="card-type visa"></div>
                            <div class="card-type amex"></div>
                            <div class="card-type discover"></div>
                          </v-flex>
                          <v-flex md12 sm12 xs12 class="0">
                            <v-text-field
                              placeholder="0000 0000 0000 0000"
                              name="Card Number"
                              label="Card Number"
                              type="Number"
                              v-model="CardNumber"
                              maxlength="7"
                              class=" input-group--focused mt-0"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex md12 sm12 xs12 class="0">
                            <v-text-field
                              name="Expire Date"
                              label="Expire Date"
                              type="text"
                              maxlength="7" placeholder="mm/yyyy"
                              v-model="ExpireDate"
                              class=" input-group--focused mt-0"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex md12 sm12 xs12 class="0">
                            <v-text-field
                              name="CVV"
                              label="CVV"
                              type="Number"
                              v-model="CVV"
                              class=" input-group--focused mt-0"
                              required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card>
                      <ConfirmSignup/>
                      <v-btn @click="createSchool =  4 " class="right card-r no-shadow">Back</v-btn>
                    </form>
                  </v-stepper-content>
                </v-stepper-items>
              </v-flex>
            </v-layout>
          </v-stepper>
        </v-form>
      </div>
    </v-container>
  </div>
</template>
<script>
	/* eslint-disable */
	import ConfirmDialog from "@/components/ConfirmDialog.vue";
	import ConfirmBooking from "@/components/ConfirmBooking.vue";
  import ConfirmPackage from "@/components/ConfirmPackage.vue"
	import OpenDays from "./OpenDays.vue";
	import { dispatch, mapState, mapActions, Store, mapMutations } from "vuex";
	import VueDawa from "vue-dawa";
	import myVideo from "vue-video";

	export default {
		data: () => ({
      createSchool: 0,
      policy:false,
      policyerror:"false",
      NextDisabled:true,
      Next2Disabled:true,
			file:'',
			clubAddress: {
				oneLineAddress: ""
			},
			adminAddress: {
				oneLineAddress: ""
			},
			modal: false,
			modal2: false,
			modal3: false,
			passwordShow: false,
			// Club
			logoURL: "",
			coverPhotoURL: "",
			attachment: {
				photos: [],
				photosURL: [],
				videos: [],
				videosURL: []
			},
			gender_: ["Male", "Female"],
			valid: false,
			name: "",
			numberRules: [
				v => !!v || "Mobile number is required",
				v => (v && v.length <= 8) || "Mobile number must be 8 characters"
			],
			requiredRule: [v => !!v || "This field is required"],
			email: "",
			emailRules: [
				v => !!v || "E-mail is required",
				v =>
					/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
					"E-mail must be valid"
			],

			passwordRules: [
				v => !!v || "Password is required",
				v => (v && v.length > 6) || "Password must be grater than 8 characters & includes lower case, upper case & special characters"
      ],
      days:['Monday','Tuesday','Wednesday','Thursday','Friday'],
      openDaysAndTime:{
          openDays:[],
          startTime:[],
          closeTime:[]
      },
      selectedPackage:[],
      SelectedPackageId:''
		}),

		computed: {
			...mapState({
				loading: "loading",
				mode: "mode",
				admin: "admin",
				club: "club",
        adminpackages:"adminpackages",
				package: "package",
				snackbar: "snackbar",
				notice: "notice",
				timeout: "timeout",
				tempAdminId: "tempAdminId"
      }),
      ...mapMutations({
        setClubAdminNull: 'setClubAdminNull'
      })
		},

		methods: {
			...mapActions(["loadAdminPackages", "addAdmin", "addClub"]),
			selectItem(payload, objectName) {
        this.$set(this, objectName, this.translateData(payload));
      },
      choosePackage(item,packageId){
        this.selectedPackage=item
        this.SelectedPackageId=packageId
      },
       CheckNextDisabled(){
          let thiss=this.club
          if(thiss.cvr  && thiss.club_name && thiss.club_phone && thiss.club_email){
            this.NextDisabled=false
          }
       },
       CheckNext2Disabled(){
          let thiss=this.admin
          if(thiss.phone && thiss.email && thiss.password){
            this.Next2Disabled=false
          }
       },
			translateData(address) {
				if (!address || !address.data) {
					return;
				}
				return {
					id: address.data.id,
					street: address.data.vejnavn,
					streetNumber: address.data.husnr,
					floor: address.data.etage,
					door: address.data.dør,
					zipCode: address.data.postnr,
					city: address.data.postnrnavn,
					oneLineAddress: address.tekst
				};
      },
			save(packageId) {

				var admin = Object.assign({}, this.admin);
				// admin.city = this.adminAddress.city;
				// admin.door = this.adminAddress.door;
				// admin.floor = this.adminAddress.floor;
				// admin.streetNumber = this.adminAddress.streetNumber;
				// admin.zipCode = this.adminAddress.zipCode;
				admin.address.oneLineAddress = this.adminAddress.oneLineAddress;
				var clubTemp = Object.assign({}, this.club);
				clubTemp.cvr_number = this.club.cvr;
				clubTemp.city = this.clubAddress.city;
				clubTemp.door = this.clubAddress.door;
				clubTemp.floor = this.clubAddress.floor;
				clubTemp.streetNumber = this.clubAddress.streetNumber;
				clubTemp.zipCode = this.clubAddress.zipCode;
				clubTemp.address.oneLineAddress = this.clubAddress.oneLineAddress;
				// clubTemp.club_logo=this.club.club_logo;
				// clubTemp.club_cover=this.club.club_cover;
        // clubTemp.opendays=this.openDaysAndTime.openDays;
        // clubTemp.club_start_time=this.openDaysAndTime.startTime;
        // clubTemp.club_end_time=this.openDaysAndTime.closeTime;
        clubTemp.admin_package_id=packageId;

        var adminData={
          email:admin.email,
          password: admin.password,
          phone: admin.phone
        }
				this.$store.dispatch("addAdmin", adminData).then(() => {
					// (Store._modules.root.state.admin)
					const admin = Object.assign({}, this.$store.state.admin.adminRes);
					if (admin.id !== null) {
						// var club=Object.assign({}, Store._modules.root.state.club)
						var club = clubTemp;
						club.admin_id = admin.id;
						// this.club.admin_id = admin.id
            var clubData={
              club_name:club.name,
              club_email:club.club_email,
              club_phone:club.club_phone,
              admin_id:club.admin_id,
              cvr_number:club.cvr_number,
              admin_package_id:packageId,
              city:club.city,
              door:club.door,
              floor:club.floor,
              streetNumber:club.streetNumber,
              zipCode:club.zipCode
            }
            this.$store.dispatch("addClub", club);
			      this.$router.push("/customers")

					}
				});
      },
      selectPackage(packageid){
      },
			onPickLogo() {
				this.$refs.logoInput.click();
			},
			OnLogoPicked(event) {
				const files = event.target.files;
				let fileName = files[0].name;
				this.club.club_logo = fileName;
				if (fileName.lastIndexOf(".") <= 0) {
					return alert("Please add a valid file! ");
				}
				const fileReader = new FileReader();
				this.club.club_logo = files[0];

				this.club.club_logo_name = files[0].name;

			},
			onPickCover() {
				this.$refs.CoverInput.click();
			},
			OnCoverPicked(event) {
				const files = event.target.files;
				let fileName = files[0].name;
				if (fileName.lastIndexOf(".") <= 0) {
					return alert("Please add a valid file! ");
				}
				this.club.club_cover=files[0];


				this.club.club_cover_name = files[0].name;

			},
			onPickImg() {
				this.$refs.ImgInput.click();
			},
			onPickVideo() {
				this.$refs.VideoInput.click();
			},
			onImgPicked() {
				const files = event.target.files;
				let fileName = files[0].name;
				if (fileName.lastIndexOf(".") <= 0) {
					return alert("Please add a valid file! ");
				}
				const fileReader = new FileReader();
				fileReader.addEventListener("load", () => {
					this.attachment.photosURL.push(fileReader.result);
				});
				fileReader.readAsDataURL(files[0]);
				this.attachment.photos.push(files[0]);
			},
			onVideoPicked() {
				const files = event.target.files;
				let fileName = files[0].name;
				if (fileName.lastIndexOf(".") <= 0) {
					return alert("Please add a valid file! ");
				}
				const fileReader = new FileReader();
				fileReader.addEventListener("load", () => {
					this.attachment.videosURL.push(fileReader.result);
				});
				fileReader.readAsDataURL(files[0]);
				this.attachment.videos.push(files[0]);
      },
      setDaysAndTime(Data){
        this.openDaysAndTime.openDays=Data.Days;
        this.openDaysAndTime.startTime=Data.startTime;
        this.openDaysAndTime.closeTime=Data.closeTime;
      }
		},
		components: {
			ConfirmBooking,
      ConfirmDialog,
      ConfirmPackage,
			VueDawa,
      myVideo,
      OpenDays

		},
		created() {
      this.$store.commit('setClubAdminNull')
      this.$store.dispatch("loadAdminPackages");

      this.$store.dispatch("addClub", club);
      this.$store.dispatch("addAdmin", adminData)
      this.$store.dispatch("getAllCustomers");
    },

    updated: function(){
      this.CheckNextDisabled()
      this.CheckNext2Disabled()
    },
	};
</script>
<style>
  .transparent{
    background-color: transparent!important;
  }
  .card-type {
    display: none;
    width: 80px;
    height: 56px;
    /*background: url("../../assets/cards.png");*/
    background-position: 0 -291px;
    background-repeat: no-repeat;
  }
  .card-type.mastercard {
    background-position: 0 0;
  }
  .card-type.visa {
    background-position: 0 -115px;
  }
  .card-type.amex {
    background-position: 0 -57px;
  }
  .card-type.discover {
    background-position: 0 -174px;
  }
  .v-stepper__header {
    margin: 24px 0px 0px 20px ;
    display: table;
    overflow: hidden;
  }
  .theme--light.v-stepper {
    /*height: 77vh;*/
    /*height: 378px;*/
    overflow: -moz-scrollbars-none;
  }
  .Formcard{
    height: -webkit-fill-available!important;
  }
  .theme--light.v-stepper .v-stepper__step__step, .theme--light.v-stepper .v-stepper__step__step .v-icon {
    color: #fff;
    padding: 15px;
    font-size: 12px;
  }
  .v-stepper__step{
    padding:  11px 48px 11px 20px;
  }
  .v-stepper__content {
    overflow: auto;
    /*height: -webkit-fill-available;*/
    /*height: 100%;*/
  }
  /* Smartphones (portrait and landscape) ----------- */
  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
    .v-stepper__header{
      display: none!important;
    }
    .v-stepper__content{
      padding: 0px !important;
    }
    .Formcard {
      height: -webkit-fill-available!important;
    }
  }
  .v-dialog{
    box-shadow: none!important;
  }
  /* Smartphones (landscape) ----------- */
  @media only screen and (min-width : 321px){
    .v-stepper__header{
      display: none!important;
    }
  }
  /* Smartphones (portrait) ----------- */
  @media only screen and (max-width : 320px) {
    .v-stepper__header{
      display: none!important;
    }
  }
  /* iPhone 4 ----------- */
  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) and (orientation : landscape) and (-webkit-min-device-pixel-ratio : 2) {
    .v-stepper__header{
      display: none!important;
    }
  }
  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio : 2) {
    .v-stepper__header{
      display: none!important;
    }
  }
  /* iPads (portrait and landscape) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) {
    .v-stepper__header{
      display: none!important;
    }
  }
  /* iPads (landscape) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) {
    .v-stepper__header{
      display: none!important;
    }
  }
  /* iPads (portrait) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
    .v-stepper__header{
      display: none!important;
    }
  }
  /* iPad 3 ---------------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) and (-webkit-min-device-pixel-ratio : 2) {
    .v-stepper__header{
      display: none!important;
    }
  }
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio : 2) {
    .v-stepper__header{
      display: none!important;
    }
  }
  /* Desktops and laptops ----------- */
  @media only screen and (min-width : 1224px) {
    .v-stepper__header{
      display: table!important;
    }
  }
  /* 960px layouts ----------- */
  @media only screen and (min-width : 960px){
    .v-stepper__header{
      display: table!important;
    }
  }
  /* Large screens ----------- */
  @media only screen and (min-width : 1824px) {
    .v-stepper__header{
      display: table!important;
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/pages/customers/AddNewCustomer.vue